export enum LocalStorageKey {
  DONT_SHOW_BROWSER_ALERT = "browser-alert:dont-show",
  BROWSER_ALERT_CLOSE_DATE = "browser-alert:close-date",
  INSTALL_BANNER_DISMISSED = "install-banner-dismissed",
  LEGENDS = "legends",
  USER = "user",
  JWT = "jwt",
  CANVAS_SETTINGS = "canvas-settings",
  SETTINGS = "settings",
  BACK_PATH = "back-path",
  EVENT_LOGS = "event-logs",
  PROJECT_ACTIVE_TAB = "project-active-tab",
  THEME_MODE = "theme-mode",
  LANGUAGE = "language",
  FINDINGS_TABLE_COLUMNS = "findings-table-columns",
  PHOTOS_VIEW_MODE = "photos-view-mode",
  PHOTO_SIZES = "photo-sizes",
  DRAWINGS_FILTERS = "drawings-filters",
  OFFLINE_SINCE = "offline-since",
  OFFLINE_BANNER_DISMISSED = "offline-banner-dismissed",
  STORAGE_BANNER_DISMISSED = "storage-banner-dismissed",
  DEVICE_ID = "device-id",
  LAST_SELECTED_FIELD_PART = "last-selected-field-part",
  FLOATING_PANEL_GEOMETRIES = "floating-panel-geometries",
  CANVAS_DRAWER_WIDTH = "canvas-drawer-width",
  CANVAS_HIDDEN_TOOLS = "canvas-hidden-tools",
  CANVAS_TOOLBAR_COLUMNS = "canvas-toolbar-columns",
  CANVAS_UI_CHANGES_SEEN = "canvas-ui-changes-seen",
}
class LocalStorage {
  setItem(key: LocalStorageKey, value: string) {
    localStorage.setItem(key, value);
  }

  getItem(key: LocalStorageKey): string | null {
    return localStorage.getItem(key);
  }

  removeItem(key: LocalStorageKey) {
    localStorage.removeItem(key);
  }

  setDateItem(key: LocalStorageKey, value: Date) {
    this.setItem(key, value.toISOString());
  }

  getDateItem(key: LocalStorageKey) {
    const value = this.getItem(key);
    return value ? new Date(value) : null;
  }

  setBooleanItem(key: LocalStorageKey, value: boolean) {
    this.setItem(key, value ? "true" : "false");
  }

  getBooleanItem(key: LocalStorageKey): boolean {
    const value = this.getItem(key);
    return value === "true";
  }

  addArrayItem(key: LocalStorageKey, value: any) {
    const existingItems = this.getItem(key);
    const itemsArray = existingItems ? JSON.parse(existingItems) : [];
    if (!itemsArray.includes(value)) {
      itemsArray.push(value);
      this.setItem(key, JSON.stringify(itemsArray));
    }
  }

  getArrayItems(key: LocalStorageKey): any[] {
    const value = this.getItem(key);
    return value ? JSON.parse(value) : [];
  }
}

const $ls = new LocalStorage();

export default $ls;
